import React from 'react';
import { Button, Badge, Separator, DropdownMenuCheckboxItem, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, } from '@cargomatic/ui';
import { PlusCircle } from 'lucide-react';
import { cn } from 'utils/ui/classes';
export function DataTableFilter({ column, title, options, className }) {
    const selectedValues = new Set(column === null || column === void 0 ? void 0 : column.getFilterValue());
    function handleFilterChange(option) {
        return (checked) => {
            if (!checked) {
                selectedValues.delete(option.value);
            }
            else {
                selectedValues.add(option.value);
            }
            const filterValues = Array.from(selectedValues);
            column === null || column === void 0 ? void 0 : column.setFilterValue(filterValues.length ? filterValues : undefined);
        };
    }
    function handleReset() {
        column.setFilterValue(undefined);
    }
    return (React.createElement(DropdownMenu, { modal: false },
        React.createElement(DropdownMenuTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: "sm", className: "border-dashed flex items-center" },
                React.createElement(PlusCircle, { className: "mr-2 h-4 w-4" }),
                title,
                (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.size) > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { orientation: "vertical", className: "mx-2 h-4" }),
                    React.createElement(Badge, { className: "rounded-sm px-1 font-normal lg:hidden" }, selectedValues.size),
                    React.createElement("div", { className: "hidden space-x-1 lg:flex" }, selectedValues.size > 2 ? (React.createElement(Badge, { className: "rounded-sm px-1 font-normal" },
                        selectedValues.size,
                        " selected")) : ((options || [])
                        .filter((option) => selectedValues.has(option.value))
                        .map((option) => (React.createElement(Badge, { key: option.value, className: "rounded-sm px-1 font-normal" }, option.label))))))))),
        React.createElement(DropdownMenuContent, { className: cn('w-[200px] p-0 overflow-y-auto', className), align: "start" },
            options.map((option) => {
                const isSelected = selectedValues.has(option.value);
                return (React.createElement(DropdownMenuCheckboxItem, { key: option.value, onCheckedChange: handleFilterChange(option), checked: isSelected },
                    React.createElement("span", null, option.label)));
            }),
            React.createElement(DropdownMenuSeparator, null),
            React.createElement(DropdownMenuItem, { onClick: handleReset, className: "pl-8" }, "Clear"))));
}
